import React, { useState, useEffect } from "react";
import { useUnidades } from "../../hooks/test/useUnidades";
import Select from "react-select";
import useCeo from "../../hooks/useCEO";
import { Spinner } from "../../components/Spinner";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleMinus } from "@fortawesome/free-solid-svg-icons";

export const AdministracionEdicionViajes = ({ }) => {
  useCeo({
    title: "Administracion de viajes",
    description: "Página de edición de viajes",
  });

  const {
    getViaje,
    getViajes,
    getTiendasCedis,
    getTiendasNegocio,
    getTripulantesIdNegocio,
    getUnitsBusqueda,
    putViajev2,
    putTripulantes,
    createRuta,
    deleteRuta,
  } = useUnidades();

  const [loading, setLoading] = useState(false);
  const [unidadesDisponibles, setUnidadesDisponibles] = useState([]);
  const [unidadSeleccionada, setUnidadSeleccionada] = useState(null);
  const [tiendasMostradas, setTiendasMostradas] = useState([]);
  const [cajaSeleccionada, setCajaSeleccionada] = useState([]);
  const [cajasMostradas, setCajasMostradas] = useState([]);
  const [tripulantes, setTripulantes] = useState([]);
  const [tripulacionSeleccionada, setTripulacionSeleccionada] = useState([]);

  const [tiendasInfo, setTiendasInfo] = useState([]);
  const [cajasInfo, setCajasInfo] = useState([]);
  const [negocioNombre, setNegocioNombre] = useState("");

  // Estados para las opciones de los Selects (catálogos)
  const [catTiendas, setCatTiendas] = useState([]);
  const [catCaja, setCatCaja] = useState([]);
  const [observaciones, setObservaciones] = useState("");

  useEffect(async () => {
    await cargarDatosIniciales();
  }, []);

  const guardarActualizarViaje = async () => {
    if (!validaciones()) return;

    const sinRol = tripulacionSeleccionada.filter(x => !x.rol);
    if (sinRol.length > 0) {
      return toast.error("Toda la tripulación debe tener un rol asignado", { position: "top-left", autoClose: 4000 });
    }
    const operadores = tripulacionSeleccionada.filter(x => x.rol === "OPERADOR");
    if (operadores.length === 0) {
      return toast.error("Debe haber al menos un operador", { position: "top-left", autoClose: 4000 });
    }

    setLoading(true);
    await actualizarTiposTripulantes();

    const viajeId = unidadSeleccionada.value;
    const soloTripulantes = tripulacionSeleccionada.filter(x => x.rol === "TRIPULANTE");
    const cajas = cajasMostradas.map(cajaId => ({ unidad_id: cajaId }));

    // Tiendas agregadas y eliminadas vs las originales
    const tiendasAgregadas = tiendasMostradas.filter(
      id => !tiendasInfo.some(r => r.tienda_id === id)
    );
    const tiendasEliminadas = tiendasInfo.filter(
      r => !tiendasMostradas.includes(r.tienda_id)
    );

    for (const tienda_id of tiendasAgregadas) {
      await createRuta({ viaje_id: viajeId, tienda_id });
    }
    for (const ruta of tiendasEliminadas) {  // <-- itera objetos, no IDs
      await deleteRuta(ruta.viaje_ruta_id);
    }

    const viajeData = {
      viaje_id: viajeId,
      descripcion: observaciones.trim(),
      chofer_id: operadores[0].tripulante_id,
      ...(operadores[1]?.tripulante_id && { operador_id: operadores[1].tripulante_id }),
      tripulantes: soloTripulantes.map(x => x.tripulante_id),
      cajas: cajasMostradas,
    };

    const response = await putViajev2(viajeData);
    setLoading(false);

    if (response && response.ok) {
      Swal.fire({ title: "Éxito", text: "Unidad actualizada correctamente", icon: "success", timer: 2500, showConfirmButton: false });
      setObservaciones("");
      await handleChangeUnidad(unidadSeleccionada);
    } else {
      toast.error((response && response.msg) || "Error al actualizar el viaje.", { position: "top-left", autoClose: 3000 });
    }
  };

  const validaciones = () => {
    if (tiendasMostradas.length === 0) {
      toast.error("Debes seleccionar al menos una tienda.", {
        position: "top-left",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    if (observaciones.trim() === "") {
      toast.error("El campo de observaciones no puede estar vacío.", {
        position: "top-left",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    return true;
  };

  const cargarDatosIniciales = async () => {
    setLoading(true);
    await cargarViajes();
    setLoading(false);
  };

  const removeCajaMostrada = (valorAEliminar) => {
    setCajasMostradas((prevArreglo) =>
      prevArreglo.filter((item) => item !== valorAEliminar)
    );
  };

  const removeTiendasMostrada = (valorAEliminar) => {
    setTiendasMostradas((prevArreglo) =>
      prevArreglo.filter((item) => item !== valorAEliminar)
    );
  };

  const handleChangeUnidad = async (selectedOption) => {
    setUnidadSeleccionada(selectedOption);
    setTiendasMostradas([]);
    setTiendasInfo([]);
    setCajasMostradas([]);
    setCajasInfo([]);
    setObservaciones("");
    setNegocioNombre(null);
    setCatTiendas([]);
    setCatCaja([]);

    const viajeId = selectedOption && selectedOption.value;

    if (viajeId) {
      setLoading(true);
      const response = await getViaje(viajeId);

      if (response && response.ok) {
        const negocioId =
          response.unidad &&
          response.unidad.negocio &&
          response.unidad.negocio.negocio_id;
        if (response.unidad && response.unidad.negocio) {
          setNegocioNombre(response.unidad.negocio.negocio_nombre);
          console.log("Se encontraron negocios del viaje", negocioNombre)
        } else {
          setNegocioNombre(null);
          console.warn("No se encontraron negocios en el viaje")
        }

        if (negocioId !== undefined && negocioId !== null) {
          // Cargar y filtrar Cajas
          let respCaja = await getUnitsBusqueda(3, negocioId);
          if (respCaja && respCaja.ok && Array.isArray(respCaja.cajas)) {
            const cajasFiltradas = respCaja.cajas.filter(
              (caja) => caja.negocio_id === negocioId
            );
            setCatCaja(cajasFiltradas);
          } else {
            console.error(
              "Error al cargar o filtrar cajas:",
              respCaja ? respCaja.msg : "Respuesta inválida"
            );
            setCatCaja([]);
          }

          const respTodos = await getTripulantesIdNegocio(negocioId);
          if (respTodos.ok) {
            setTripulantes(respTodos.tripulantes);
          } else {
            setTripulantes([]);
          }

          // Cargar Tiendas
          let respTienda;
          let cediNegocioId = null;
          if (response.unidad && response.unidad.cedi) {
            cediNegocioId = response.unidad.cedi.negocio_id;
          }
          const cedisId = response.cedis_id;

          if (cediNegocioId !== undefined && cediNegocioId !== null) {
            if (cediNegocioId !== 1) {
              respTienda = await getTiendasNegocio(cediNegocioId);
            } else if (cedisId !== undefined) {
              respTienda = await getTiendasCedis(cedisId);
            }
          } else if (cedisId !== undefined) {
            respTienda = await getTiendasCedis(cedisId);
          } else {
            respTienda = await getTiendasNegocio(negocioId);
          }

          if (
            respTienda &&
            respTienda.ok &&
            respTienda.tiendas &&
            Array.isArray(respTienda.tiendas)
          ) {
            setCatTiendas(respTienda.tiendas);
          } else {
            console.error(
              "Error al cargar tiendas:",
              (respTienda && respTienda.msg) ? respTienda.msg : "Respuesta invalida o error"
            );
            setCatTiendas([]);
          }
        } else {
          console.warn("No se pudo obtener el negocio_id para filtrar catálogos.");
          setCatTiendas([]);
          setCatCaja([]);
        }

        // Mapear tripulación inicial del viaje
        const operadoresMapeados = [];
        if (response.chofer) {
          operadoresMapeados.push({
            tripulante_id: response.chofer_id,
            nombre: response.chofer.nombre_completo,
            telefono: response.chofer.telefono,
            rol: "OPERADOR",
            tipo_tripulante_id: 1,
          });
        }
        if (response.operador) {
          operadoresMapeados.push({
            tripulante_id: response.operador.tripulante_id,
            nombre: response.operador.nombre_completo,
            telefono: response.operador.telefono,
            rol: "OPERADOR",
            tipo_tripulante_id: 1,
          });
        }
        const tripulantesMapeados = (response.tripulantes_viajes || [])
          .filter(tv => tv.tripulante?.tipo_tripulante_id === 2)
          .map(tv => ({
            tripulante_id: tv.tripulante_id,
            nombre: tv.tripulante?.nombre_completo || "",
            telefono: tv.tripulante?.telefono || "",
            rol: "TRIPULANTE",
            tipo_tripulante_id: 2,
          }));

        setTripulacionSeleccionada([...operadoresMapeados, ...tripulantesMapeados]);

        if (response.ruta && Array.isArray(response.ruta)) {
          console.log("Rutas_viajes encontradas:", response.ruta);
          const rutasActivas = response.ruta.filter(rt => rt.isActive === 1);
          setTiendasInfo(rutasActivas); // guarda { viaje_ruta_id, tienda_id } completo
          setTiendasMostradas(rutasActivas.map(rt => rt.tienda_id));
        } else {
          console.warn("response.rutas_viajes no esta presente o no es un array.")
          setTiendasMostradas([]);
          setTiendasInfo([]);
        }

        setObservaciones(response.descripcion || "");

        if (response.unidades_cajas && Array.isArray(response.unidades_cajas)) {
          const initialCajas = response.unidades_cajas
            .map((x) => (x.caja ? x.caja.unidad_id : undefined))
            .filter((id) => id !== undefined && id != null);

          setCajasMostradas(initialCajas);
          setCajasInfo(initialCajas);
        } else {
          setCajasMostradas([]);
          setCajasInfo([]);
        }

        setLoading(false);
      } else {
        Swal.fire({
          title: "Error al cargar los detalles del viaje",
          text: (response && response.msg) ? response.msg : "Ocurrió un error desconocido.",
          icon: "error",
        });
        setNegocioNombre(null);
        setUnidadSeleccionada(null);
        setCatTiendas([]);
        setCatCaja([]);
        setTiendasMostradas([]);
        setTiendasInfo([]);
        setCajasMostradas([]);
        setCajasInfo([]);
        setObservaciones("");
        setTripulacionSeleccionada([]);
        setTripulantes([]);
        setLoading(false);
      }
    } else {
      setNegocioNombre(null);
      setUnidadSeleccionada(null);
      setCatTiendas([]);
      setCatCaja([]);
      setTiendasMostradas([]);
      setTiendasInfo([]);
      setCajasMostradas([]);
      setCajasInfo([]);
      setObservaciones("");
      setTripulacionSeleccionada([]);
      setTripulantes([]);
    }
  };

  const actualizarTiposTripulantes = async () => {
    const actualizaciones = [];
    for (const seleccionado of tripulacionSeleccionada) {
      const original = tripulantes.find(x => x.tripulante_id === seleccionado.tripulante_id);
      if (!original) continue;
      const tipoDeseado = seleccionado.rol === "OPERADOR" ? 1 : 2;
      if (original.tipo_tripulante_id !== tipoDeseado) {
        actualizaciones.push(
          putTripulantes(seleccionado.tripulante_id, { tipo_tripulante_id: tipoDeseado })
        );
      }
    }
    await Promise.all(actualizaciones);
  };

  const cargarViajes = async () => {
    let response = await getViajes();
    if (response.ok) {
      const opcionesSelect = response.viajes.map((viaje) => ({
        value: viaje.viaje_id,
        label: (viaje.unidad && viaje.unidad.unidad_numero) ? viaje.unidad.unidad_numero : "Unidad sin número",
      }));
      setUnidadesDisponibles(opcionesSelect);
    } else {
      Swal.fire({
        title: "Error al cargar los viajes",
        text: response.msg,
        icon: "error",
      });
    }
  };

  return (
    <>
      {loading && <Spinner />}
      <form>
        <div className="container">
          <div className="row mb-3 justify-content-center align-items-end mt-2">
            <div className=" form-group col-md-4 flex-column d-flex ">
              <Select
                id="unidad"
                name="unidad"
                options={unidadesDisponibles}
                placeholder="Buscar Unidad"
                value={unidadSeleccionada}
                onChange={handleChangeUnidad}
                isSearchable
                className="form-control form-select selectCedis"
              />
            </div>
          </div>

          <div className="card card-viajes">
            <div>
              <div className="row mb-2 justify-content-center">
                <div className=" col-auto flex-column d-flex text-start">
                  <label className="form-label">
                    <h4>
                      <strong>
                        ACTUALIZACIÓN DE VIAJE
                        &nbsp;
                        {negocioNombre && `- ${negocioNombre} - `}
                        UNIDAD{" "}
                        {unidadSeleccionada ? unidadSeleccionada.label : ""}{" "}
                      </strong>
                    </h4>
                  </label>
                </div>
              </div>

              <div className="row mb-5 justify-content-between">
                <div className="form-group col-12 flex-column d-flex">
                  <label className="form-label">Tripulación</label>
                  <Select
                    isMulti
                    options={tripulantes.map((x) => {
                      const yaSeleccionado = tripulacionSeleccionada.find(
                        y => y.tripulante_id === x.tripulante_id
                      );
                      return {
                        value: x.tripulante_id,
                        label: `${x.nombre_completo} ${x.telefono}`,
                        data: x,
                        isDisabled:
                          x.ocupado ||
                          (tripulacionSeleccionada.length >= 4 && !yaSeleccionado),
                      };
                    })}
                    value={tripulacionSeleccionada.map(p => ({
                      value: p.tripulante_id,
                      label: `${p.nombre} ${p.telefono}`,
                      data: { nombre_completo: p.nombre, telefono: p.telefono, tipo_tripulante_id: p.tipo_tripulante_id },
                    }))}
                    className="mb-2"
                    classNamePrefix="select"
                    placeholder="Selecciona tripulación"
                    onChange={(elementos) => {
                      const nuevaLista = elementos.map((x) => {
                        const existente = tripulacionSeleccionada.find(
                          y => y.tripulante_id === x.value
                        );
                        return {
                          tripulante_id: x.value,
                          nombre: x.data.nombre_completo,
                          telefono: x.data.telefono,
                          rol: existente?.rol || null,
                          tipo_tripulante_id: x.data?.tipo_tripulante_id,
                        };
                      });
                      setTripulacionSeleccionada(nuevaLista);
                    }}
                  />

                  {tripulacionSeleccionada.map((persona) => (
                    <div className="card p-2 mb-2" key={persona.tripulante_id}>
                      <div className="row align-items-center">
                        <div className="col-6 text-center">
                          <strong>{persona.nombre}</strong>
                          <br />
                          <small className="text-muted">{persona.telefono}</small>
                        </div>
                        <div className="col-6">
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              type="button"
                              className={persona.rol === "OPERADOR" ? "btn btn-primary btn-sm" : "btn btn-outline-primary btn-sm"}
                              onClick={() => {
                                setTripulacionSeleccionada(prev => {
                                  const operadoresActuales = prev.filter(
                                    x => x.rol === "OPERADOR" && x.tripulante_id !== persona.tripulante_id
                                  );
                                  if (operadoresActuales.length >= 2) {
                                    Swal.fire({ icon: "warning", text: "Máximo 2 operadores" });
                                    return prev;
                                  }
                                  return prev.map(x =>
                                    x.tripulante_id === persona.tripulante_id
                                      ? { ...x, rol: "OPERADOR", tipo_tripulante_id: 1 }
                                      : x
                                  );
                                });
                              }}
                            >
                              Operador
                            </button>
                            <button
                              type="button"
                              className={persona.rol === "TRIPULANTE" ? "btn btn-success btn-sm" : "btn btn-outline-success btn-sm"}
                              onClick={() => {
                                setTripulacionSeleccionada(prev => {
                                  const tripulantesActuales = prev.filter(
                                    x => x.rol === "TRIPULANTE" && x.tripulante_id !== persona.tripulante_id
                                  );
                                  if (tripulantesActuales.length >= 2) {
                                    Swal.fire({ icon: "warning", text: "Máximo 2 tripulantes" });
                                    return prev;
                                  }
                                  return prev.map(x =>
                                    x.tripulante_id === persona.tripulante_id
                                      ? { ...x, rol: "TRIPULANTE", tipo_tripulante_id: 2 }
                                      : x
                                  );
                                });
                              }}
                            >
                              Tripulante
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="row mb-5 mt-5 justify-content-between">
                <div className=" form-group col-5 flex-column d-flex">
                  <label className="form-label">Tiendas*</label>
                  <Select
                    options={catTiendas.map((tienda) => {
                      const isDisabled = tiendasMostradas.includes(tienda.tienda_id);
                      return {
                        value: tienda.tienda_id,
                        label: tienda.tienda_nombre,
                        isDisabled: isDisabled,
                      };
                    })}
                    isSearchable
                    isClearable={true}
                    className="mb-2 form-control"
                    classNamePrefix={"select"}
                    name="destino"
                    value={null}
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        if (!tiendasMostradas.includes(selectedOption.value)) {
                          setTiendasMostradas([
                            ...tiendasMostradas,
                            selectedOption.value,
                          ]);
                        } else {
                          Swal.fire({
                            title: "Ya seleccionada",
                            text: "Esta tienda ya ha sido añadida.",
                            icon: "info",
                            timer: 2000,
                            showConfirmButton: false,
                          });
                        }
                      }
                    }}
                    placeholder="Seleccione Tienda"
                  />

                  <div className="mt-1 mb-3">
                    {/* Se pintan las tiendas */}
                    {tiendasMostradas.map((tiendaId) => {
                      const tienda = catTiendas.find(
                        (t) => t.tienda_id === tiendaId
                      );
                      if (tienda) {
                        return (
                          <>
                            <div className="row" key={tienda.tienda_id}>
                              <FontAwesomeIcon
                                className=" d-flex fa-solid col-sm-auto cursor"
                                style={{
                                  color: "#ff0000",
                                  height: "1.2rem",
                                  width: "1rem",
                                }}
                                icon={faCircleMinus}
                                onClick={() => {
                                  removeTiendasMostrada(tienda.tienda_id);
                                }}
                              />
                              <h5
                                className=" col d-flex"
                              >
                                {tienda.tienda_nombre}
                              </h5>
                            </div>
                          </>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>

                <div className=" form-group col-5 flex-column d-flex">
                  <label className="form-label">Cajas</label>
                  <Select
                    options={catCaja
                      .filter((x) => x.baja === 0)
                      .map((x) => {
                        let find = cajaSeleccionada.find(
                          (y) => y === x.unidad_id
                        );
                        return {
                          value: x.unidad_id,
                          label: `${x.unidad_numero}`,
                          isDisabled:
                            x.unidad_disponible === 0 ||
                            cajasMostradas.includes(x.unidad_id),
                        };
                      })}
                    value={null}
                    isSearchable
                    isClearable={true}
                    className="mb-2 form-control"
                    classNamePrefix={"select"}
                    name="cajas"
                    placeholder="Seleccione Cajas"
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        if (cajasMostradas.length < 2) {
                          if (!cajasMostradas.includes(selectedOption.value)) {
                            setCajasMostradas([
                              ...cajasMostradas,
                              selectedOption.value,
                            ]);
                          } else {
                            Swal.fire({
                              title: "Ya seleccionada",
                              text: "Esta caja ya fue añadida",
                              icon: "info",
                              timer: 3000,
                              showConfirmButton: false,
                            });
                          }
                        } else {
                          Swal.fire({
                            title: "Límite alcanzado",
                            text: "Solo se pueden seleccionar hasta 2 cajas.",
                            icon: "warning",
                            timer: 3000,
                            showConfirmButton: false,
                          });
                        }
                      }
                    }}
                  />
                  {(cajasInfo && cajasInfo.length > 0) ||
                    (cajasMostradas && cajasMostradas.length > 0) ? (
                    <div className="mt-1">
                      {/* Se pintan las cajas */}
                      {cajasMostradas.map((cajaId) => {
                        let caja = catCaja.find((x) => x.unidad_id === cajaId);
                        if (caja) {
                          return (
                            <>
                              <div className=" row" key={caja.unidad_id}>
                                <FontAwesomeIcon
                                  className="d-flex fa-solid col-sm-auto cursor"
                                  style={{
                                    color: "#ff0000",
                                    height: "1.2rem",
                                    width: "1rem",
                                  }}
                                  icon={faCircleMinus}
                                  onClick={() => {
                                    removeCajaMostrada(caja.unidad_id);
                                  }}
                                />
                                <h5
                                  className=" col d-flex"
                                >
                                  {caja.unidad_numero}
                                </h5>
                              </div>
                            </>
                          );
                        }
                        return null;
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className=" form-group col-12 flex-column d-flex">
                  <label className=" form-label">Observaciones*</label>
                  <textarea
                    className=" form-control form-control-plaintext mb-3 "
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                  />
                </div>
              </div>
              <div className="row justify-content-end">
                <button
                  className=" col-auto flex-column d-flex btn btn-primary text-white"
                  onClick={(e) => {
                    e.preventDefault();
                    guardarActualizarViaje();
                  }}
                  disabled={loading}
                >
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};